import React from "react"
import { Link } from "gatsby"
import Title from "../Globals/Title"

export default function info() {
  return (
    <section className="ps-5">
      <div className="container">
        <Title title="our story" />
        <div className="row">
          <div className="col-10 col-sm-8 mb-2 mx-auto text-center">
            <p className="lead text-muted mb-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora
              quis, dolore consequatur maiores reiciendis cum distinctio? Ullam,
              ex ducimus soluta exercitationem illum, quidem dolorem possimus
              neque pariatur saepe laborum accusamus.
            </p>
            <Link to="/about/">
              <button className="btn text-uppercase btn-yellow">
                About Page
              </button>
  
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
